export const INSURANCE_TYPES = [
    {
        value: "",
        text: "\u00a0"
    },
    {
        value: "NONE",
        text: "Нет"
    },
    {
        value: "OMS",
        text: "Только OMC"
    },
    {
        value: "DMS",
        text: "Только ДМС"
    },
    {
        value: "OMS_AND_DMS",
        text: "ОМС и ДМС"
    }
];
export const DEGREES = [
    {
        value: "",
        text: "\u00a0"
    },
    {
        value: "NONE",
        text: "Нет"
    },
    {
        value: "KMN",
        text: "КМН"
    },
    {
        value: "DMN",
        text: "ДМН"
    }
];

export const CATEGORIES = [
    { value: "", text: "\u00a0" },
    { value: "NONE", text: 'Нет категории' },
    { value: "FIRST", text: 'Первая категория' },
    { value: "SECOND", text: 'Вторая категория' },
    { value: "TOP", text: 'Высшая категория'}
]

export const RANKS = [
    { value: "", text: "\u00a0" },
    { value: "NONE", text: "Нет звания" },
    { value: "PROFESSOR", text: "Профессор" },
    { value: "DOCENT", text: "Доцент" },
]

export const FRONTEND_URL = "https://doctu.ru";

export const STORAGE_PUBLIC = "/storage.public";

export const DOCTOR_MOD_TYPES = {
    "EXTERNAL": 'анкета Внешняя',
    "PERSONAL": 'анкета Врача',
    "NETWORK": 'анкета Сети',
    "PRIMARY": 'Основная анкета',
    "LINK": 'анкета LINK',
};
export const PRICELISTS_STATUSES = {
    'NEW': 'Новый',
    'PARSED': 'Обработан',
    'PARSING_PROBLEM': 'Проблема обработки',
    'MATCHED': 'Тегирован',
    'MATCHING_PROBLEM': 'Проблема тегирования',
    'MODERATED': 'Промодерирован',
    'MODERATION_PROBLEM': 'Отклонён',
    'PUBLISHED': 'Опубликован',
};

function getTimeOptions() {
    let result = [];
    for (let i = 0; i <= 24; i++) {
        for (let j = 0; j <= 30; j += 30) {
            result.push({
                value: String(i).padStart(2, '0') + ':' + String(j).padStart(2, '0'),
                fromText: (i === 24)
                    ? null
                    : ('с ' + i + ':' + String(j).padStart(2, '0')),
                tillText: (i === 24 && j === 30)
                    ? null
                    : 'до ' + i + ':' + String(j).padStart(2, '0')
            });
        }
    }

    return result.filter(row => {
        return (typeof row.fromText !== "undefined" && row.fromText != null) ||
            (typeof row.tillText !== "undefined" && row.tillText != null);
    });
}

export const TIME_OPTIONS = [
    {
        value: "",
        text: "\u00a0"
    },
    ...getTimeOptions().map(({tillText, value}) => {
        return {
            text: tillText,
            value: value
        };
    })
];
export const TIME_OPTIONS_WORK = [
    {
        value: "",
        text: "\u00a0"
    },
    {
        value: "24h",
        text: "Круглосуточно"
    },
    ...getTimeOptions().map(({fromText, value}) => {
        return {
            text: fromText,
            value: value
        };
    })
];

export const TIME_OPTIONS_FULL = [
    {
        value: "",
        text: "\u00a0"
    },
    {
        value: "24h",
        text: "Круглосуточно"
    },
    {
        value: "off",
        text: "Выходной"
    },
    ...getTimeOptions().map(({fromText, value}) => {
        return {
            text: fromText,
            value: value
        };
    })
];

